<template>
  <el-dialog
    v-if="isShowing"
    :visible.sync="isShowing"
    :fullscreen="isFullScreen"
    :title="(row)? 'Update':'Create'"
    :before-close="closeDialog"
  >
    <el-form
      ref="form"
      v-loading="isSaving"
      :rules="rules"
      :model="form"
    >
      <el-row :gutter="15">
        <el-col :md="24">
          <el-form-item
            label="Name"
            prop="name"
          >
            <el-input
              v-model="form.name"
              placeholder="Name"
              clearable
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row
        v-if="form.type"
        :gutter="15"
      >
        <el-col :md="24">
          <el-form-item
            label="Type"
            prop="type"
          >
            <el-select
              v-model="form.type"
              placeholder="Please select an Model Type"
              :loading="isSaving"
              class="w-100"
              @change="selectedType"
            >
              <el-option
                v-for="item in typeList"
                :key="item.id"
                :label="item.name"
                :value="item"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="15">
        <el-col :md="24">
          <el-form-item
            label="Description"
            prop="description"
          >
            <el-input
              v-model="form.description"
              type="textarea"
              :rows="5"
              placeholder="Description"
              clearable
              :loading="loading"
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span
      slot="footer"
      class="dialog-footer"
    >
      <el-button
        type="default"
        @click.native="isFullScreen = ! isFullScreen"
      >
        <FontAwesomeIcon
          v-if="isFullScreen"
          :icon="['fal', 'compress']"
        />
        <FontAwesomeIcon
          v-else
          :icon="['fal', 'expand']"
        />
      </el-button>
      <el-button
        type="default"
        @click.native="closeDialog"
      >
        Cancel
      </el-button>
      <el-button
        type="primary"
        :loading="isSaving"
        @click.native="create"
      >
        {{ (row)? 'Update':'Create' }}
      </el-button>
    </span>
  </el-dialog>
</template>
<script>
export default {
  props: {
    assetManufacturer: {
      type: String,
      required: false,
      default: null
    }
  },
  data () {
    return {
      isShowing: false,
      isSaving: false,
      typeList: null,
      isFullScreen: false,
      form: {
        name: null,
        description: null,
        type: null
      },
      rules: {
        name: [
          { required: true, message: 'Please type in name', trigger: 'blur' }
        ],
        description: [
          { required: true, message: 'Please type in description', trigger: 'blur' }
        ]
      },
      row: null,
      loading: false
    }
  },
  created () {
    this.loadTypeLists()
  },
  methods: {
    selectedType (row) {
      this.$forceUpdate()
    },
    showCreateDialog () {
      this.isShowing = true
    },
    showEditForm (row) {
      this.form = {
        name: row.name,
        description: row.description
      }
      if (row.manufacturer) {
        this.assetManufacturer = row.manufacturer.id
      }
      this.row = row
      this.showCreateDialog()
    },
    setTypeToYes () {
      this.rules.type = [
        { required: true, message: 'Please type in description', trigger: 'change' }
      ]
      this.loadTypeLists()
      if (!this.form.type) {
        this.form.type = 'select'
      }
    },
    loadTypeLists () {
      this.loading = true
      this.$sdk.asset_type.list(builder => {})
        .then(res => {
          this.typeList = res
        })
        .finally(() => { this.loading = false })
    },
    create () {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.isSaving = true
          if (!this.row) {
            this.$emit('save', this.form)
          } else {
            this.row.name = this.form.name
            this.row.description = this.form.description
            this.row.update(builder => {
              if (this.assetManufacturer) {
                builder.context = { resource: 'assetmanufacturer', id: this.assetManufacturer }
              }
            }).then(() => this.$message({ message: 'Successfully saved', type: 'success' }))
              .finally(() => {
                this.closeDialog()
                this.$emit('reload')
              })
          }
        }
      })
    },
    closeDialog () {
      this.isShowing = false
      this.isSaving = false
      this.reset()
    },
    reset () {
      this.form = {
        name: null,
        description: null
      }
      this.row = null
    }
  }
}
</script>
